import { isNumber } from "lodash"
import { BLANK_TARGET } from "../../shared_component/constants/autoglass"

export const MAP_STYLE = "mapbox://styles/mapbox/streets-v11"
export const DEFAULT_MAP_WIDTH = "100%"
export const DEFAULT_MAP_HEIGHT = "100%"
export const DEFAULT_LATITUDE = 41.8786772
export const DEFAULT_LONGITUDE = -87.6451561
export const DEFAULT_ZOOM = 9

export const USE_CURRENT_LOCATION = "use-current-location"

export const GOOGLE_MAP_BASE_URL = "https://www.google.com/maps?q="
